export default __webpack_public_path__ + "static/media/icon-dosierung.7c05e25d.svg";